import React, { createContext, useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import client from '../api/client';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const { data: settings, isLoading } = useQuery({
        queryKey: ['settings'],
        queryFn: async () => (await client.get('/settings')).data,
        staleTime: 1000 * 60 * 5, // 5 minutes
        enabled: !!localStorage.getItem('token'),
    });

    const currency = useMemo(() => settings?.company_currency || '₽', [settings]);

    return (
        <SettingsContext.Provider value={{ settings, currency, isLoading }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};
